import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import './BillTypeTemplateSummaryThermal.css';

function ShiftDevicePrint() {
  const { billTypeSummary, showSubHeaders } = useSelector(
    (state) => state.posReportshiftSlice
  );
  const decimalPosition = localStorage.getItem("decimalPosition") || 2;

  const summary = billTypeSummary?.device;
  const deviceRows = useMemo(() => summary?.list || [], [summary?.list]);

  const getAssignedNames = (items, key) =>
    (Array.isArray(items) ? items : [])
      .map((item) => item?.[key])
      .filter(Boolean)
      .join(", ") || "-";

  return (
    <div
      className="thermal-receipt-container"
    >
      <div className="bill-main-head">
        <h5 style={{ width: "25%" }}>Device</h5>
        <h5 style={{ width: "20%" }}>Employee</h5>
        <h5 style={{ width: "10%", textAlign: "center" }}>Count</h5>
        {showSubHeaders ? (
          <>
            <h5 style={{ width: "15%", textAlign: "right" }}>Amount</h5>
            <h5 style={{ width: "15%", textAlign: "right" }}>Paid</h5>
            <h5 style={{ width: "15%", textAlign: "right" }}>Balance</h5>
          </>
        ) : (
          <h5 style={{ width: "45%", textAlign: "right" }}>Paid</h5>
        )}
      </div>

      {deviceRows.length === 0 ? (
        <div className="bill-sub-head">
          <h5>No Devices Available</h5>
        </div>
      ) : (
        deviceRows.map((device) => {
          // Get actual employees who took orders (from employees array)
          const actualEmployees = getAssignedNames(
            device?.employees,
            "employeeName"
          );

          return (
            <React.Fragment key={device?.deviceId || device?.deviceCode || device?.deviceName}>
              <div className="bill-sub-head">
                <h5 style={{ width: "25%" }}>
                  {device?.deviceName || "Unassigned Device"}
                  {device?.deviceCode ? (
                    <span style={{ display: "block", fontSize: 11 }}>
                      Code: {device.deviceCode}
                    </span>
                  ) : null}
                </h5>
                <h5 style={{ width: "20%" }}>{actualEmployees}</h5>
                <h5 style={{ width: "10%", textAlign: "center" }}>{device?.count || 0}</h5>
                {showSubHeaders ? (
                  <>
                    <h5 style={{ width: "15%", textAlign: "right" }}>{(device?.amount || 0).toFixed(decimalPosition)}</h5>
                    <h5 style={{ width: "15%", textAlign: "right" }}>{(device?.paidAmount || 0).toFixed(decimalPosition)}</h5>
                    <h5 style={{ width: "15%", textAlign: "right" }}>{(device?.balanceAmount || 0).toFixed(decimalPosition)}</h5>
                  </>
                ) : (
                  <h5 style={{ width: "45%", textAlign: "right" }}>{(device?.paidAmount || 0).toFixed(decimalPosition)}</h5>
                )}
              </div>

              {showSubHeaders && (
                <div style={{ backgroundColor: "#fafafa", borderBottom: "1px solid #dcdcdc" }}>
                  {/* Category-wise Sales */}
                  {Array.isArray(device?.categorySales) && device.categorySales.length > 0 && (
                    <div style={{ marginBottom: "8px" }}>
                      <div className="bill-main-head" style={{ backgroundColor: "#e3f2fd" }}>
                        <h5 style={{ width: "60%", fontWeight: "600", paddingLeft: "20px" }}>Category</h5>
                        <h5 style={{ width: "40%", fontWeight: "600", textAlign: "right", paddingRight: "20px" }}>Sales Amount</h5>
                      </div>
                      {device.categorySales.map((cat, idx) => (
                        <div
                          className="bill-sub-head"
                          style={{ 
                            backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f5f5f5",
                            borderBottom: "1px solid #e0e0e0"
                          }}
                          key={(cat?.categoryId || cat?.categoryName || idx) + "-cat"}
                        >
                          <h5 style={{ width: "60%", fontSize: "13px", paddingLeft: "20px" }}>{cat?.categoryName || "Uncategorized"}</h5>
                          <h5 style={{ width: "40%", fontSize: "13px", textAlign: "right", paddingRight: "20px" }}>{(cat?.amount || 0).toFixed(decimalPosition)}</h5>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Order Type Breakdown */}
                  {(device?.orderTypeBreakdown?.diningCount > 0 || 
                    device?.orderTypeBreakdown?.takeawayCount > 0 || 
                    device?.orderTypeBreakdown?.deliveryCount > 0) && (
                    <div>
                      <div className="bill-main-head" style={{ backgroundColor: "#fff3e0" }}>
                        <h5 style={{ width: "33.33%", fontWeight: "600", textAlign: "center" }}>Dining</h5>
                        <h5 style={{ width: "33.33%", fontWeight: "600", textAlign: "center" }}>Takeaway</h5>
                        <h5 style={{ width: "33.34%", fontWeight: "600", textAlign: "center" }}>Delivery Partner</h5>
                      </div>
                      <div
                        className="bill-sub-head"
                        style={{ 
                          backgroundColor: "#ffffff",
                          borderBottom: "1px solid #e0e0e0"
                        }}
                      >
                        <h5 style={{ width: "33.33%", fontSize: "14px", fontWeight: "500", textAlign: "center" }}>
                          {device?.orderTypeBreakdown?.diningCount || 0}
                        </h5>
                        <h5 style={{ width: "33.33%", fontSize: "14px", fontWeight: "500", textAlign: "center" }}>
                          {device?.orderTypeBreakdown?.takeawayCount || 0}
                        </h5>
                        <h5 style={{ width: "33.34%", fontSize: "14px", fontWeight: "500", textAlign: "center" }}>
                          {device?.orderTypeBreakdown?.deliveryCount || 0}
                        </h5>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </React.Fragment>
          );
        })
      )}

      <div className="bill-main-head">
        <h5 style={{ width: "25%" }}>All Devices</h5>
        <h5 style={{ width: "20%" }}>—</h5>
        <h5 style={{ width: "10%", textAlign: "center" }}>{summary?.count || 0}</h5>
        {showSubHeaders ? (
          <>
            <h5 style={{ width: "15%", textAlign: "right" }}>{(summary?.total || 0).toFixed(decimalPosition)}</h5>
            <h5 style={{ width: "15%", textAlign: "right" }}>{(summary?.totalPaid || 0).toFixed(decimalPosition)}</h5>
            <h5 style={{ width: "15%", textAlign: "right" }}>{(summary?.totalBalance || 0).toFixed(decimalPosition)}</h5>
          </>
        ) : (
          <h5 style={{ width: "45%", textAlign: "right" }}>{(summary?.totalPaid || 0).toFixed(decimalPosition)}</h5>
        )}
      </div>
    </div>
  );
}

export default ShiftDevicePrint;